































import { Component, Prop, Vue } from 'vue-property-decorator';

export type SectionWrapperConfig = {
  descriptionMaxWidth?: string;
  borderRadius?: string;
  background?: string;
  padding?: string;
  titleFontSize?: string;
  headerMarginBottom?: string;
};

const defaultConfig = {
  descriptionMaxWidth: '100%',
  borderRadius: '16px',
  background: 'white',
  padding: '32px',
  titleFontSize: '20px',
  headerMarginBottom: '24px'
};

@Component({
  components: {}
})
export default class SectionWrapper extends Vue {
  @Prop(String) title?: string;
  @Prop(String) description!: string;
  @Prop({ default: () => defaultConfig }) config!: SectionWrapperConfig;

  get configOptions() {
    return {
      ...defaultConfig,
      ...this.config
    };
  }

  get wrapperStyle() {
    return {
      borderRadius: this.configOptions.borderRadius,
      background: this.configOptions.background,
      padding: this.configOptions.padding
    };
  }

  get descriptionStyle() {
    return {
      maxWidth: this.configOptions.descriptionMaxWidth
    };
  }

  get titleStyle() {
    return {
      '--title-font-size': this.configOptions.titleFontSize
    };
  }

  get headerStyle() {
    return {
      '--header-margin-bottom': this.configOptions.headerMarginBottom
    };
  }
}
